import styled from 'styled-components';

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const ButtonBack = styled.div`
    border: 0px;
    width: 30px;
    min-width: 30px;
    height: 30px;
    min-height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;

    &:before {
        transition: color .4s ease 0s;
        content: '\\F004D';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 25px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: "#fff";
    }
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${p => p.align ?? 'stretch'};
    justify-content: stretch;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px;
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color ?? '#fff'};
    color: ${props => props.color ?? '#fff'};
    width: 120px;
    height: 30px;
    min-width: 120px;
    min-height: 30px;
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor ?? '#000' };
        background-color: ${props => props.color ?? '#fff'};
    }
`;

export const MessagesList = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    margin: 0 50px;
    flex-wrap: wrap;
    position: relative;
`;

export const MessagesFriendsList = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 30%;
    bottom: 0;
    border-right: 1px solid #555;
    padding-right: 20px;
    margin: 0 0 20px 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const MessageListMessages = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 70%;
    bottom: 70px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const MessageFriendsTitle = styled.div`
    color: #666;
    font-size: 18px;
    text-transform: uppercase;
    margin-bottom: 20px;
`;

export const MessageFriendItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    padding: 10px;
    cursor: pointer;
    background-color: transparent;

    &:hover {
        background-color: #555;
    }
    
    &.selected:not(:hover) {
        background-color: #494949;
    }
`;

export const MessageFriendLetter = styled.div.attrs(p => ({
    style: {
        backgroundColor: p.color ?? '#000',
        color: p.fgColor ?? '#fff'
    }
}))`
    height: 40px;
    width: 40px;
    font-size: 20px;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const MessageFriendName = styled.div`
    color: #fff;
    font-size: 14px;
    margin: 0 10px;

    &.off {
        color: #999;
    }
`;

export const MessageFriendUnread = styled.div`
    color: #fff;
    background-color: #156D15;
    font-weight: 700;
    font-size: 14px;
    height: 25px;
    min-width: 25px;
    border-radius: 12px;
    padding-top: 3px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const NoMessage = styled.div`
    height: 100%;
    width: 300px;
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 14px;
    text-align: center;
    line-height: 20px;

    &:before {
        width: 180px;
        height: 180px;
        color: #333;
        font-size: 130px;
        font-family: 'Material Design Icons';
        content: '\\F12F2';
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
    }

    &.noFriends:before {
        margin-top: -30px;
        content: '\\F0010';
    }

    &.noMessage:before {
        margin-top: -30px;
        content: '\\F164D';
    }
`;



export const FriendHeader = styled.div`
    color: #666;
    font-size: 18px;
    text-transform: uppercase;
    margin: 0 0 20px 20px;
`;

export const Conversation = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    flex: 1;
    
`;

export const SendMessageRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    border-top: 1px solid #555;
    padding: 10px 10px 20px 10px;
    position: absolute;
    bottom: 0;
    left: 30%;
    right: 0;
    height:70px;
`;

export const SendMessageInput = styled.input.attrs(p => ({
    type: "text"
}))`
    border: 1px solid #999;
    background-color: #000;
    padding: 5px;
    height: 35px;
    box-sizing: border-box;
    flex: 1;
    margin-right: 10px;
    color: #fff;
`;

export const SendMessageButton = styled.div`
    height: 35px;
    width: 35px;
    background-color: #777;
    position: relative;
    cursor: pointer;
    color: #000;
    transition: all .4s ease 0s;

    &:hover {
        background-color: #999;
    }

    &:before {
        content: '\\F048A';
        color: #fff;
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const MessageLine = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    &.left {
        justify-content: flex-start;
    }

    &.right {
        justify-content: flex-end;
    }
`;

export const Message = styled.div`
    color: #fff;
    padding: 10px;
    position: relative;
    font-size: 14px;
    max-width: 60%;
    margin: 0 0 10px 20px;
    line-height: 20px;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        width: 0;
        height: 0;
        border: 10px solid transparent;
    }
`;

export const MessageTime = styled.div`
    color: rgba(255,255,255, 0.5);
    position: absolute;
    font-size: 10px;
    bottom: -3px;
    right: 1px;
`;

export const MessageMine = styled(Message)`
    background-color: #444;
    margin: 0 10px 10px 20px;

    &:before {
        right: -10px;
        border-top: 10px solid #444;
    }
`;

export const MessageOther = styled(Message)`
    background-color: #5C5C5C;
    margin: 0 0 10px 30px;
    
    &:before {
        left: -10px;
        border-top: 10px solid #5C5C5C;
    }
`;

export const MsgJoin = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const MsgJoinTableImage = styled.div`
    height: 50px;
    width: 50px;
    min-height: 50px;
    min-width: 50px;
    background-color: #000;
    margin-right: 10px;
    position: relative;
`;

export const MsgJoinTableName = styled.div`
    font-size: 18px;
`;

export const MsgJoinText = styled.div`
    font-size: 14px;
    margin-bottom: 5px;
    color: #ccc;
    font-style: italic;
`;
